import {FETCH_HADITH_CHAPTER_CONTENT} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_HADITH_CHAPTER_CONTENT:
            return action.payload;
        default:
            return state;
    }
};